import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { useQuery } from "@tanstack/react-query";

export function useAskRedoReturnQuery(
  returnId: string | undefined,
  queryKey: string,
) {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  return useQuery({
    queryKey: [queryKey, returnId],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const result = await rpcClient.getReturn({ returnId: returnId! });
      return result.data;
    },
    enabled: !!returnId,
  });
}
